import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class XmlLogIndexdbService {
  public tableName = "ba_ndc_xml_logs";

 addXmlLog(logDetail:{label:string,xml:string},db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let xmlLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName);
        let countRequest = xmlLogStore.count();
        countRequest.onsuccess = function (countRequestEvent:any) {
            let xmlCount:any = countRequestEvent.target.result;
            logDetail.label = logDetail.label+(xmlCount+1);
            xmlLogStore.put(logDetail);
            xmlLogStore.onsuccess = function (event:any) {
              if(event.target.result){
                resolve(true);
              }else{
                resolve(false);
              }
            };
        }
      }
    });
  }
  getXmlLogByLabel(key:any,db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let xmlLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName);
        const labelIndex = xmlLogStore.index("label");
        const getLogByKeyQuery = labelIndex.getAll([key]);
        getLogByKeyQuery.onsuccess = function (event:any) {
          if(event.target.result){
            let selectedLogDetail = event.target.result;
            resolve(selectedLogDetail);
          }else{
            resolve([]);
          }
        }
      }
    });
  }
  getXmlLogs(db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let xmlLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName);
        const getAllXmlLogQuery = xmlLogStore.getAll();
        getAllXmlLogQuery.onsuccess = function (event:any) {
          if(event.target.result){
            resolve(event.target.result);
          }else{
            resolve([]);
          }
        };
      }
    });
  }
  removeXmlLogFromIndexDbByKey(label:any,db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let xmlLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName);
        const labelIndex = xmlLogStore.index("label");
        const getLogByKeyQuery = labelIndex.getAll([label]);
        getLogByKeyQuery.onsuccess = function (event:any) {
          if(event.target.result){
            let selectedLogDetail = event.target.result[0];
            let selectedLogKey = selectedLogDetail.id;
            let deleteRequest = xmlLogStore.delete(selectedLogKey);
            deleteRequest.onsuccess = function (event:any) {
              if(event.target.result){
                resolve(true);
              }else{
                resolve(false);
              }
            };
          }else{
            resolve(false);
          }
        };
      }
    });
  }
  deleteAllLogs(db:any){
    return new Promise(async(resolve:any,reject:any)=>{
      if(typeof db !== 'undefined'){
        let xmlLogStore = await db.transaction([this.tableName],'readwrite')
        .objectStore(this.tableName).clear();
        xmlLogStore.onsuccess = function (event:any) {
          if(event.target.result){
            resolve(true);
          }else{
            resolve(false);
          } 
        };
      }
    });
  }
}